import type { SearchUser, User } from 'lib-shared-types-api';

/**
 * Gets the display name of the user.
 *
 * @param user The User or SearchUser object.
 * @param fallback The fallback display name.
 */
export function getUserDisplayName(
  user: User | SearchUser,
  fallback = 'Unknown',
): string {
  const { anonymized_at, email, phone_number } = user;
  const contactOptions = [email, phone_number].filter(Boolean);
  const name = 'name' in user ? getUserName(user) : user.display_name;
  return (
    name ??
    contactOptions[0] ??
    (anonymized_at ? 'Anonymized user' : undefined) ??
    fallback
  );
}

function getUserName(user: User) {
  const { family_name, given_name, name } = user;

  const fullName =
    given_name && family_name ? `${given_name} ${family_name}` : undefined;

  return name ?? fullName ?? given_name;
}
